import { render, staticRenderFns } from "./BasicAccountDetails.vue?vue&type=template&id=148221c1&"
import script from "./BasicAccountDetails.vue?vue&type=script&lang=ts&"
export * from "./BasicAccountDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports